module.exports = __webpack_public_path__ + "img/2025-11-17c_12.6b62ab06.jpg";